import { IMonoOccurrence, IMonoOccurrenceOptions } from '../../../../../core/services/mono-occurrence.service';
import { IEcranDetailsResourcesEntite } from '../../../../../core/resources/ecran-details.resource';
import { IFormulaire, IFormulaireClass } from '../../../../../core/services/formulaire/formulaire.service';
import { IFormulaireItemSautDeLigneClass } from '../../../../../core/services/formulaire/formulaire-item-saut-de-ligne.service';
import { IFormulaireItemClass } from '../../../../../core/services/formulaire/formulaire-item.service';
import { IComponentController } from 'angular';
import { IFormulaireGroupeAccordeonClass } from '../../../../../core/services/formulaire/formulaire-groupe-accordeon.service';
import { IFormulaireGroupeClass } from '../../../../../core/services/formulaire/formulaire-groupe.service';
import { IRoute } from '../../../../../core/interfaces/route.interface';
import { IMenuItemForage, IMenuItemForageClass } from '../../../../../core/services/menu/menu-item-forage.service';
import { IMultiOccurrenceOptions } from '../../../../../core/services/multi-occurrence.service';
import { IMenuItemActionClass } from '../../../../../core/services/menu/menu-item-action.service';
import { IMenuClass } from '../../../../../core/services/menu/menu.service';
import { IMenuItemEcranClass } from '../../../../../core/services/menu/menu-item-ecran.service';
import { IFormulaireItemDividerClass } from '../../../../../core/services/formulaire/formulaire-item-divider.service';
import { IStateService } from "angular-ui-router";

interface IPageCP0005 extends IComponentController {
    monoOccurrence: IMonoOccurrence,
    monoOccurrenceOptions: IMonoOccurrenceOptions;
    valeursEcran: any;
    formulaireStatut: IFormulaire;
    formulaireIndicateurs: IFormulaire;
    mesFormulaire: IFormulaire;
    btnMenus: Array<IMenuItemForage>;
    scbMultiOccurrenceOptions: IMultiOccurrenceOptions;
    ccaMultiOccurrenceOptions: IMultiOccurrenceOptions;
    cfnMultiOccurrenceOptions: IMultiOccurrenceOptions;
    fcnMultiOccurrenceOptions: IMultiOccurrenceOptions;
    radMultiOccurrenceOptions: IMultiOccurrenceOptions;
    iinMultiOccurrenceOptions: IMultiOccurrenceOptions;
}

/* @ngInject */
export default function Cp0005Controller(ecranDetails: IEcranDetailsResourcesEntite,
    Formulaire: IFormulaireClass,
    FormulaireItemSautDeLigne: IFormulaireItemSautDeLigneClass,
    FormulaireItem: IFormulaireItemClass,
    FormulaireGroupe: IFormulaireGroupeClass,
    FormulaireGroupeAccordeon: IFormulaireGroupeAccordeonClass,
    FormulaireItemDivider: IFormulaireItemDividerClass,
    cp0007Route: IRoute,
    cr0004Route: IRoute,
    cp1010Route: IRoute,
    cp0009Route: IRoute,
    cp2016Route: IRoute,
    cp2017Route: IRoute,
    mc0046Route: IRoute,
    mc1011Route: IRoute,
    mc1014Route: IRoute,
    mc1010Route: IRoute,
    cp0035Route: IRoute,
    MenuItemForage: IMenuItemForageClass,
    MenuItemEcran: IMenuItemEcranClass,
    Menu: IMenuClass,
    MenuItemAction: IMenuItemActionClass,
    $state: IStateService) {

    const vm: IPageCP0005 = this;

    vm.valeursEcran = ecranDetails.valeurs;

    vm.forageSolde = new MenuItemEcran(
        'LBL_BTN_SOLDE_CAP',
        cp2017Route.NAME,
        (data: any) => ({ 
            refcleint: data.refcleint 
        }),
        {
            hidden: (data:any) => (!data.flgaccsolde),
            icon: 'launch',
            fonction: 'BOUDSR',
            iconButton: true
        }
    );

    const foragePfl = [
        new MenuItemForage(
            'LBL_PROFIL_CAP',
            cp0007Route.NAME,
            (data: any) => ({ pflcleint: data.pflcleint }),
            {
                hidden: (data: any) => (!data.$id),
                icon: 'exit_to_app',
                fonction: 'BOUPFL'
            }
        )
    ];

    const forageCrp = [
        new MenuItemForage(
            'LBL_PROFIL_CAR',
            cr0004Route.NAME,
            (data: any) => ({ crpcleint: data.crpcleint }),
            {
                hidden: (data: any) => (!data.$id),
                icon: 'exit_to_app',
                fonction: 'BOUCRP'
            }
        )
    ];

    const forageEnt = [
        new MenuItemForage(
            'BTN_FORAGE_ENT',
            cp1010Route.NAME,
            (data: any) => ({
                entcleint: data.entcleint,
                ecran: '00-2',
            }),
            {
                hidden: (data: any) => (!data.entcleint || !data.$id),
                fonction: 'BOUENTPAI',
                icon: 'exit_to_app'
            }
        )
    ];

    const forageMop = [
        new MenuItemForage(
            'BTN_FORAGE_MOP',
            cp0009Route.NAME,
            (data: any) => ({
                mopcleint: vm.monoOccurrence.data.mopcleint
            }),
            {
                hidden: (data: any) => (data.flghiddenbtnmodpai),
                fonction: 'BOUMOPPAI',
                icon: 'exit_to_app'
            }
        )
    ];

    const forageRena = [
        new MenuItemEcran(
            'LBL_BTN_FORAGE_RENA',
            cp2016Route.NAME,
            () => ({
                foucleint: vm.monoOccurrence.data.foucleint
            }),
            {
                icon: 'launch',
                fonction: 'BOURENA',
                iconButton: true
            }
        )
    ];

    vm.btnMenus = [
        new MenuItemEcran(
            'LBL_BTN_IMPUTATION',
            mc0046Route.NAME,
            (data: any) => ({ vaeusient: 'FOU', uvicleintref: data.refcleint }),
            {
                icon: '',
                fonction: 'BOUIMP',
                iconButton: false,
                secondaire: true
            }
        ),
        new MenuItemEcran(
            'LBL_BTN_RETENUE',
            mc1011Route.NAME,
            (data:any) => ({ refcleint: data.refcleint }),
            {
                icon: '',
                fonction: 'BOURET',
                iconButton: false,
                secondaire: true,
                disabled: (data: any) => !data.$id,
            }
        ),
        new MenuItemEcran(
            'LBL_BTN_MESS_CHEQUE',
            mc1010Route.NAME,
            (data:any) => ({ refcleint: data.refcleint,
                             ecran: '00-2'
             }),
            {
                icon: '',
                fonction: 'BOUMSGCHQ',
                iconButton: false,
                secondaire: true,
                disabled: false
            }
        ),

        new MenuItemEcran(
            'LBL_BTN_CARTE_ACHAT',
            cp0035Route.NAME,
            (data:any) => ({ refcleint: data.refcleint }),
            {
                icon: '',
                fonction: 'BOUCAC',
                iconButton: false,
                secondaire: true,
                hidden: (data: any) => data.flghiddenbtncarach
            }
        ),
        new MenuItemEcran(
            'LBL_BTN_TOLERANCE',
            mc1014Route.NAME,
            (data:any) => ({ tolcleintref: data.foucleint,
                             vaeustent: 'FOU'
             }),
            {
                icon: '',
                fonction: 'BOUTOL',
                iconButton: false,
                secondaire: true,
                hidden: false,
                disabled: (data: any) => !data.$id,
            }
        )
    ];

    vm.monoOccurrenceOptions = {
        fonctions: {
            boutonDupliquer: false
        },
        formulaire: new Formulaire('LBL_BLC_FOU', [
            new FormulaireItem('foucod'),
            new FormulaireItem('tfocleint', { hidden: (data) => (data.flghiddentfocleint ), readonly: (data) => (data.flgreadonlytfocleint)}),
            new FormulaireItem('founom', { modelOptions: { updateOn: 'blur' }, hidden: (data) => (data.flghiddenfounom ), readonly: (data) => (data.flgreadonlyfounom)  }),
            new FormulaireItem('founomabr', { hidden: (data) => (data.flghiddenfounomabr ), readonly: (data) => (data.flgreadonlyfounomabr) }),
            new FormulaireItem('pflcleint', { menu: foragePfl, hidden: (data) => (data.flghiddenpflcleint ), readonly: (data) => (data.flgreadonlypflcleint) }),
            new FormulaireItem('crpcleint', { menu: forageCrp }),
            new FormulaireItem('vaesysdevcod', {hidden: (data) => (data.flghiddenvaesysdevcod ), readonly: (data) => (data.flgreadonlydevcod) }),
            new FormulaireItem('vecsyslng', { hidden: (data) => (data.flghiddenvecsyslng ), readonly: (data) => (data.flgreadonlyvecsyslng)  }),
            new FormulaireItem('fouadrcou', { hidden: (data) => (data.flghiddenfouadrcou ), readonly: (data) => (data.flgreadonlyfouadrcou)  }),
            new FormulaireItem('fousitint'),
            new FormulaireItem('vectypapp', { hidden: (data) => (data.flghiddenvectypapp ), readonly: (data) => (data.flgreadonlyvectypapp)  }),
            new FormulaireItemSautDeLigne(),
            new FormulaireGroupe('LBL_BLC_INFO_TAXES',
                new Formulaire([
                    new FormulaireItem('founumtvq', { hidden: (data) => (data.flghiddenfounumtvq ), readonly: (data) => (data.flgreadonlyfounumtvq)  }),
                    new FormulaireItem('founumtps', { hidden: (data) => (data.flghiddenfounumtps ), readonly: (data) => (data.flgreadonlyfounumtps)  }),
                    new FormulaireItem('founumneq', { hidden: (data) => (data.flghiddenfounumneq ), readonly: (data) => (data.flgreadonlyfounumneq)}),
                    new FormulaireItem('taxcleint', { largeur: 100, hidden: (data) => (data.flghiddentaxcleint ), readonly: (data) => (data.flgreadonlytaxcleint )  })
                ]), { largeur: 50 }
            ),
            new FormulaireGroupe('LBL_BLC_AUTRES_INFOS',
                new Formulaire([
                    new FormulaireItem('fogcleint', { largeur: 100, hidden: (data) => (data.flghiddenfogcleint ), readonly: (data) => (data.flgreadonlyfogcleint) }),
                    new FormulaireItem('entcleint', { largeur: 100, menu: forageEnt, hidden: (data) => (data.flghiddenentcleint ), readonly: (data) => (data.flgreadonlyentcleint) }),
                    new FormulaireItem('mopcleint', { largeur: 100, menu: forageMop, hidden: (data) => (data.flghiddenmopcleint ), readonly: (data) => (data.flgreadonlymopcleint) })
                ]), { largeur: 50 }
            ),

            new FormulaireGroupeAccordeon('LBL_ACCORDEON_PROFIL_ACHAT', new Formulaire([
                new FormulaireItem('teccleint', { hidden: (data) => (data.flghiddenteccleint ), readonly: (data) => (data.flgreadonlyteccleint)}),
                new FormulaireItem('motcleint', { hidden: (data) => (data.flghiddenmotcleint ), readonly: (data) => (data.flgreadonlymotcleint)}),
                new FormulaireItem('iaccleint', { hidden: (data) => (data.flghiddeniaccleint ), readonly: (data) => (data.flgreadonlyiaccleint) }),
                new FormulaireItem('vecsysregadm', { hidden: (data) => (data.flghiddenvecsysregadm ), readonly: (data) => (data.flgreadonlyvecsysregadm)}),
                new FormulaireItem('vecsysmodtra', { hidden: (data) => (data.flghiddenvecsysmodtra ), readonly: (data) => (data.flgreadonlyvecsysmodtra)}),
                new FormulaireItem('vecsystercom', { hidden: (data) => (data.flghiddenvecsystercom ), readonly: (data) => (data.flgreadonlyvecsystercom)}),
                new FormulaireItem('foumntlimcmd'),
                new FormulaireItem('fouflgent'),
                new FormulaireItem('founbrjrs'),
                new FormulaireItem('foudes', { largeur: 66.66,  hidden: (data) => (data.flghiddenfoudes), readonly: (data) => (data.flgreadonlyfoudes)  }),
                new FormulaireItem('vaesysdacxml'),
            ], { largeurDefaut: 33.33 })),
            new FormulaireGroupeAccordeon('LBL_INFO_INTERNATIONAL', new Formulaire([
                new FormulaireGroupe('LBL_BLC_INST_FINANCIERE',
                    new Formulaire([
                        new FormulaireItem('fouintins', { largeur: 100 }),
                        new FormulaireItem('fouintadrl01', { largeur: 100 }),
                        new FormulaireItem('fouintadrl02', { largeur: 100 }),
                        new FormulaireItem('fouintzip', { largeur: 100 }),
                        new FormulaireItem('fouintvil', { largeur: 100 }),
                        new FormulaireItem('fouintpay', { largeur: 100 }),
                        new FormulaireItem('fouintpro', { largeur: 100 }),
                        new FormulaireItem('fouinttel', { largeur: 100 })
                    ]), { largeur: 50 }
                ),
                new FormulaireGroupe('LBL_BLC_DONNEES_BANCAIRES',
                    new Formulaire([
                        new FormulaireItem('fouintbic', { largeur: 100 }),
                        new FormulaireItem('fouintiba', { largeur: 100 }),
                        new FormulaireItem('pyscleint', { largeur: 100 }),
                        new FormulaireItem('fouintflgcpt', { largeur: 100 }),
                        new FormulaireItem('fouintaut', { largeur: 100, enableCount: true })
                    ]), { largeur: 50 }
                ),    
            ], { largeurDefaut: 33.33}), {hidden: (data) => !data.flgaccinfint }),
            new FormulaireGroupeAccordeon('LBL_T4A_RELEVE1', new Formulaire([
                new FormulaireItem('founam_t4a'),
                new FormulaireItem('fouprn_t4a'),
                new FormulaireItem('founas_t4a'),
                new FormulaireItem('vaecleint'),
            ], { largeurDefaut: 50 }), {hidden: (data) => !data.flgacct4arel1}),
        ], { largeurDefaut: 50 })
    };

    vm.formulaireStatut = new Formulaire('LBL_STATUT', [
        new FormulaireItem('foudatdeb', { hidden: (data) => (data.flghiddenfoudatdeb ), readonly: (data) => (data.flgreadonlyfoudatdeb)} ),
        new FormulaireItem('fouflgstu', { default: 1, hidden: (data) => (data.flghiddenfouflgstu ), readonly: (data) => (data.flgreadonlyfouflgstu ) }),
        new FormulaireItem('foudatfin', { hidden: (data) => (data.flghiddenfoudatfin ), readonly: (data) => (data.flgreadonlyfoudatfin )}),
        new FormulaireItem('foudatrena', { menu: forageRena })
    ], { largeurDefaut: 50 });

    vm.formulaireIndicateurs = new Formulaire('LBL_INDICATEURS', [
        new FormulaireItem('fouindfrsacc', { hidden: (data) => (data.flghiddenfouindfrsacc ), readonly: (data) => (data.flgreadonlyfouindfrsacc )} ),
        new FormulaireItem('fouflgimptfe', { hidden: (data) => (data.flghiddenfouflgimptfe ), readonly: (data) => (data.flgreadonlyfouflgimptfe )}),
        new FormulaireItem('fouflgpayuni'),
        new FormulaireItem('fouflgcom')
    ]);

    // Message/Description autres
    vm.mesFormulaire = new Formulaire('LBL_BLC_MES', [
        new FormulaireItem('foumcmdsc'),
        new FormulaireItem('foudacmsg'),
        new FormulaireItem('fouinsdacmsg')
    ], { largeurDefaut: 100 });

    vm.scbMultiOccurrenceOptions = {
        bloc: 'scb',
        fonctions: {
            boutonDupliquer: false
        },
        actionsMoreLigne: new Menu([
            new MenuItemAction(
                'LBL_BOU_APPROUVER',
                'BOUUSRAPR',
                () => ({}),
                {
                    icon: 'check',
                    class: 'md-raised ex-button-action',
                    hidden: (data: any) => !data.scbflgaprreq,
                    disabled: (data: any) => data.flgdisabledbtnconcpt,
                    successAction: () => $state.reload()
                }
            )
        ]),
        colonnesVisibles: [
            { nom: 'scbfmt', largeur: 100 },
            { nom: 'scbdateff', largeur: 100 },
            { nom: 'scbdsc', largeur: 100 },
            { nom: 'scbaprreqdsc', largeur: 100 }
        ],
        colonnesCachees: [
            'scbflgaprreq', 'flgdisabledbtnconcpt', 'scbcleint'
        ],
        formulaire: new Formulaire([
            new FormulaireItem('inscleint', { largeur: 100 }),
            new FormulaireItem('succleint', { largeur: 100 }),
            new FormulaireItem('scbfol'),
            new FormulaireItem('scbdateff')
        ])
    };

    // Categorie d'achat
    vm.ccaMultiOccurrenceOptions = {
        bloc: 'cca',
        fonctions: {
            boutonDupliquer: false
        },
        colonnesVisibles: [
            { nom: 'caacod', largeur: 100 },
            { nom: 'caadsc', largeur: 100 },
            { nom: 'ccaflgpri', largeur: 100 }
        ],
        formulaire: new Formulaire([
            new FormulaireItem('caacleint'),
            new FormulaireItem('ccaflgpri')
        ])
    };

    // Nibs
    vm.cfnMultiOccurrenceOptions = {
        bloc: 'cfn',
        colonnesVisibles: [
            { nom: 'nibcod', largeur: 100 },
            { nom: 'nibnom', largeur: 100 },
            { nom: 'cfndatdeb', largeur: 100 },
            { nom: 'cfndatfin', largeur: 100 }
        ],
        formulaire: new Formulaire([
            new FormulaireItem('nibcleint', { largeur: 100 }),
            new FormulaireItem('cfndatdeb'),
            new FormulaireItem('cfndatfin')
        ])
    };

    vm.fcnMultiOccurrenceOptions = {
        bloc: 'fcn',
        colonnesFixesGauche: [
            { nom: 'fcntit', largeur: 180 },
            { nom: 'fcnnom', largeur: 180 }
        ],
        colonnesVisibles: [
            { nom: 'fcnnumtel', largeur: 150 },
            { nom: 'fcnnumtelpos', largeur: 150 },
            { nom: 'fcnnumfax', largeur: 150 },
            { nom: 'fcnnumref', largeur: 150 },
            { nom: 'vecsyscodtel_dsc', largeur: 180 },
            { nom: 'fcnnumtelaut', largeur: 150 },
            { nom: 'fcnadrcou', largeur: 200 },
            { nom: 'fcnflgstu', largeur: 120 },
            { nom: 'fcncom', largeur: 250 }
        ],
        formulaire: new Formulaire([
            new FormulaireItem('fcntit'),
            new FormulaireItem('fcnnom'),
            new FormulaireItem('fcnflgstu', { default: 1 }),
            new FormulaireItem('fcnnumtel'),
            new FormulaireItem('fcnnumtelpos'),
            new FormulaireItem('fcnnumfax'),
            new FormulaireItem('fcnnumref'),
            new FormulaireItem('vecsyscodtel'),
            new FormulaireItem('fcnnumtelaut'),
            new FormulaireItem('fcnadrcou'),
            new FormulaireItem('fcncom', { largeur: 100 })
        ], { largeurDefaut: 33.33 })
    };

    vm.radMultiOccurrenceOptions = {
        bloc: 'rad',
        colonnesFixesGauche: [
            { nom: 'radcod', largeur: 100 },
            { nom: 'radadrl01', largeur: 250 },
        ],
        colonnesVisibles: [
            { nom: 'radadrl02', largeur: 250 },
            { nom: 'radvil', largeur: 150 },
            { nom: 'radpro', largeur: 150 },
            { nom: 'radcodpos', largeur: 120 },
            { nom: 'radcodced', largeur: 150 },
            { nom: 'radpay', largeur: 150 },
            { nom: 'radnumtel', largeur: 120 },
            { nom: 'radnumtelpos', largeur: 100 },
            { nom: 'radnumfax', largeur: 120 },
            { nom: 'vecfaxcodspe_dsc', largeur: 120 },
            { nom: 'radadrcou', largeur: 250 },
            { nom: 'radflgfaxint', largeur: 250 },
            { nom: 'radflgstu', largeur: 100 },
            { nom: 'raddatdeb', largeur: 126 },
            { nom: 'radflgpai', largeur: 130 },
            { nom: 'radflgach', largeur: 130 },
            { nom: 'radflgdef', largeur: 130 },
            { nom: 'radflgret', largeur: 130 },
            { nom: 'radflgfac', largeur: 130 },
            { nom: 'radflgetacpt', largeur: 130 },
            { nom: 'radnom', largeur: 250 }
        ],
        formulaire: new Formulaire([
            new FormulaireItem('radcod'),
            new FormulaireItem('radadrl01'),
            new FormulaireItem('radadrl02'),
            new FormulaireItem('radflgstu', { default: 1 }),
            new FormulaireItem('radvil'),
            new FormulaireItem('radpro'),
            new FormulaireItem('radcodpos'),
            new FormulaireItem('raddatdeb'),
            new FormulaireItem('radcodced'),
            new FormulaireItem('radpay'),
            new FormulaireItem('radnumtel'),
            new FormulaireItem('radnumtelpos'),
            new FormulaireItem('radnumfax'),
            new FormulaireItem('vecfaxcodspe'),
            new FormulaireItem('radadrcou'),
            new FormulaireItem('radflgfaxint'),
            new FormulaireItemSautDeLigne(),
            new FormulaireItem('radflgpai'),
            new FormulaireItem('radflgach'),
            new FormulaireItem('radflgdef'),
            new FormulaireItem('radflgret'),
            new FormulaireItem('radflgfac'),
            new FormulaireItem('radflgetacpt'),
            new FormulaireItem('radnom', { largeur: 50 })
        ], { largeurDefaut: 25 })
    };
}
